/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'star_filled': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M24.008 92c-.414 0-.828-.129-1.176-.383a1.998 1.998 0 01-.797-1.957l4.786-27.906L6.548 41.988a1.999 1.999 0 011.105-3.41l28.02-4.07L48.208 9.113a2.002 2.002 0 013.586 0l12.531 25.39 28.02 4.071a1.996 1.996 0 011.105 3.41l-20.27 19.77 4.786 27.906a2 2 0 01-2.903 2.11L50.001 78.594 24.94 91.77c-.293.156-.613.23-.93.23z"/>'
  }
})
